<template>
  <div>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="jobName" @click="$emit('resetJobName')">
      <close-icon class="h6 mb-0 mr-1" /> {{ jobName }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="selectedCountry" @click="$emit('resetCountry')">
      <close-icon class="h6 mb-0 mr-1" /> {{ selectedCountry }}
    </label>

     <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="selectedStates" @click="$emit('resetState')" v-for="state in selectedStates">
      <close-icon class="h6 mb-0 mr-1" /> {{ states.find(stateData => stateData.abbr == state).name }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white text-capitalize" v-if="selectedCities" @click="$emit('resetCity')" v-for="city in selectedCities">
      <close-icon class="h6 mb-0 mr-1" />{{ city.toLowerCase() }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="selectedTeam" @click="$emit('resetTeam')">
      <close-icon class="h6 mb-0 mr-1" />{{ $store.state.teams.find((team) => team.slug == selectedTeam).title }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="selectedNeighborhoods" @click="$emit('resetNeighborhood')">
      <close-icon class="h6 mb-0 mr-1" />{{ selectedNeighborhoods }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="zipcode" @click="$emit('resetZipcode')">
      <close-icon class="h6 mb-0 mr-1" />{{ zipcode }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="radius" @click="$emit('resetRadius')">
      <close-icon class="h6 mb-0 mr-1" />{{ radius }}Km
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="selectedLevel" @click="$emit('resetLevel')">
      <close-icon class="h6 mb-0 mr-1" />{{ levels.find(level => level.id == selectedLevel).name }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="selectedArea" @click="$emit('resetArea')">
      <close-icon class="h6 mb-0 mr-1" />{{ areas.find(area => area.id == selectedArea).name }}
    </label>

    <label class="badge badge-pill badge-color-1 mx-1 font-weight-normal p-2 d-inline-flex align-items-center text-white" v-if="selectedPCD" @click="$emit('resetPCD')">
      <close-icon class="h6 mb-0 mr-1" />PCD
    </label>
  </div>
</template>

<script>
  import CloseIcon from "vue-material-design-icons/Close.vue"

  export default {
    name: 'FiltersBadges',

    props: {
      jobName: String,
      selectedCountry: String,
      selectedStates: Array,
      selectedStore: String,
      selectedStoreCity: String,
      selectedNeighborhoods: String,
      zipcode: String,
      radius: String,
      selectedCities: Array,
      selectedTeam: String,
      selectedLevel: String,
      selectedArea: String,
      selectedPCD: Boolean,
      selectedTemporary: Boolean
    },

    computed: {
      countries() {
        return ['Brasil', 'Argentina']
      },

      levels(){
        return this.$store.state.domains.professional_experience_levels || [];
      },

      areas() {
        return this.$store.state.areas || [];
      },

      states(){
        return this.$store.state.domains.states || [];
      },

      cities(){
        return this.$store.state.domains.cities || [];
      },
    },

    components: {
      CloseIcon
    }
  }
</script>